import React from 'react';

import type { ThumbnailMetadata } from '../utils/videoUtils';

interface ThumbnailProps {
  src: string;
  thumbnail: ThumbnailMetadata;
}

/**
 * Renders a single filmstrip thumbnail using a <video> element that seeks
 * to the target timestamp. The browser displays the frame natively — no
 * canvas capture or caching involved. One render, zero swaps.
 */
export default function Thumbnail({ src = '', thumbnail }: ThumbnailProps) {
  return (
    <video
      className="flex-shrink-0 object-cover select-none pointer-events-none"
      style={{
        width: thumbnail.width,
        height: thumbnail.height,
      }}
      src={src}
      crossOrigin="anonymous"
      muted
      playsInline
      draggable={false}
      onLoadedMetadata={(e) => {
        e.currentTarget.currentTime = thumbnail.timeInSeconds;
      }}
      onError={() => {
        console.error('Error loading thumbnail', src, thumbnail);
      }}
    />
  );
}
